export default __webpack_public_path__ + "static/media/charcuterie.9dcd08df.webp";